/**
 * Pure phone formatting helper for the Edit Profile dialog. No React, no i18n — just
 * input→output, mirroring `paymentAccount.format.ts`'s shape. ZIP formatting/validation lives in
 * `@mdvip/shared/lib/us-zip` — payments' billing address needs the identical rule, so it isn't
 * feature-local like this file's phone helpers (payments has no phone field).
 */

export function stripPhoneFormatting(value: string): string {
  return value.replace(/\D/g, '');
}

/** Mask a raw phone entry into "(xxx) xxx-xxxx" as the user types. */
export function formatPhone(value: string): string {
  const digits = stripPhoneFormatting(value).slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
